import { ArrowRightOutlined } from "@ant-design/icons"
import { Button, Input } from "antd"
import { useNoReplySelf } from "../controller/NoReplySelfController"
import { useEffect, useRef, useState } from "react"
import { useAutoReply } from "../../../components/auto_reply/controller/AutoReplyController"
import { ChatBotPicture, ChatBotPictureOwer } from "../image/ChatBotPicture"
import { useEditorMessage } from "../../../components/editor_message/controller/EditorMessageController";

const ChatRoom = () => {
    const [message_new, setMessageNew] = useState("");
    const endRef = useRef()
    const [chatLineData, setChatLineData] = useState([

    ])
    const [loading, setLoading] = useState(false)
    const [inputValue, setInputValue] = useState("")
    const onFinish = ({ axiosMode, status, values }) => {
        if (axiosMode === "post") {
            if (status === "success") {
                let no_reply_autoreply_data = values?.no_reply_autoreply_data
                setChatLineData((pre => {
                    let replyMessages = [];
                    let replyMessage = ""
                    if (!no_reply_autoreply_data) {
                        // replyMessage = `很抱歉機器人小編無法理解您的問題，真人小編稍後上線為您服務。<br/>(暑假期間，圖書館禮拜五及7/4~7/11休館，真人小編暫停服務)<br/>暑假開館詳細開放時間:<a href="https://lib.pccu.edu.tw/p/404-1012-127984.php?Lang=zh-tw">https://lib.pccu.edu.tw/p/404-1012-127984.php?Lang=zh-tw</a> <br/><br/>※真人小編平日上線服務時間為9:00~16:00<br/>例假日、國定假日真人小編暫停服務，請您耐心等候回覆，不便之處敬請見諒`
                        replyMessage = message_new
                        replyMessages.push({
                            owner: false,
                            messageText: getLink(replyMessage)
                        })
                    }
                    else {
                        no_reply_autoreply_data.forEach(no_reply_autoreply_data_first => {
                            // let no_reply_autoreply_data_first = no_reply_autoreply_data.find((ele) => true)
                            if (no_reply_autoreply_data_first?.name === "手動回覆") {
                                replyMessage = no_reply_autoreply_data_first.context
                            } else {
                                let can_data = no_reply_autoreply_data_first?.can_data || []
                                let can_data_first = can_data.find((ele) => true)
                                let message = can_data_first?.can_message
                                let temp = can_data.map((keyword_data) => {
                                    let content = '';
                                    for (let i = 0; i < Object.keys(keyword_data).length; i++) {
                                        content = content + (keyword_data?.can_message[i] ?? { content: '' }).content;
                                    }
                                    replyMessage = content
                                })
                            }
                            replyMessages.push({
                                owner: false,
                                messageText: getLink(replyMessage)
                            })
                        })
                    }
                    return [
                        ...pre,
                        ...replyMessages
                    ]
                }))
            }
        }
        setLoading(false)
    }
    const getLink = (inputString) => {
        var urlPattern = /(<p>|^|)(https?:\/\/[^\s<>]+)(<\/p>|\s|$)/g;
        var replacedString = inputString

        // 替换匹配的网址为超链接
        if (String(inputString || '').match(/<img[^>]*>/)) {
            console.log(String(inputString || '').match(/<img[^>]*>/))
        } else {
            replacedString = String(inputString || '').replace(urlPattern, '$1<a href="$2">$2</a>$3');
        }


        // console.log(replacedString)
        return replacedString.replaceAll("\n", "<br/>")

    }
    const onBefore = () => {
        setLoading(true)
    }
    const Send = () => {
        if (!inputValue.trim()) {  // 檢查 inputValue 是否為空或只有空格
            // console.log("訊息為空，無法發送");
            return;  // 如果是空的，結束函數執行
        }
        let datas = [
            {
                content: inputValue
            }
        ]
        // console.log(datas)
        setChatLineData((pre => {
            return [
                ...pre,
                {
                    owner: true,
                    messageText: getLink(inputValue)
                }
            ]
        }))
        postNoReplySelfData(datas)
    }
    const sendKeyWord = (content) => {
        let datas = [
            {
                content: content
            }
        ]
        setChatLineData((pre => {
            return [
                ...pre,
                {
                    owner: true,
                    messageText: content
                }
            ]
        }))
        postNoReplySelfData(datas)
    }
    const {
        EditorMessageData,
        getEditorMessageData,
        postEditorMessageData,
        patchEditorMessageData,
        deleteEditorMessageData,
    } = useEditorMessage({
        onFinish,
        onBefore,
    })
    useEffect(() => {
        // getEditorMessageData()
        // console.log('EditorMessageData_', EditorMessageData)
        return getEditorMessageData()
    }, [])
    useEffect(() => {
        // console.log('latestMessage', EditorMessageData);
        if (EditorMessageData.length > 0) {
            const sortedData = [...EditorMessageData].sort((a, b) =>
                b.editor_message_id - a.editor_message_id
            );
            const latestMessage = sortedData[0].editor_message;
            setMessageNew(latestMessage); 
        }
    }, [EditorMessageData]);
    
    useEffect(() => {
        // console.log('message_new has been updated:', message_new);
        // 在這裡進行 message_new 更新後的邏輯處理
    }, [message_new]);
    const {
        getAutoReplyOption,
        autoReplyOption
    } = useAutoReply({
        onFinish: () => { },
        onBefore: () => { },
    })
    const {
        noReplySelfData,
        getNoReplySelfData,
        postNoReplySelfData
    } = useNoReplySelf({
        onFinish: onFinish,
        onBefore: onBefore
    })
    useEffect(() => {
        setChatLineData((pre => {
            let alltemp = []
            noReplySelfData.reverse().forEach((element) => {
                let replyMessage = ""
                let content = element?.content
                let no_reply_autoreply_data = element?.no_reply_autoreply_data
                alltemp.push({
                    owner: true,
                    messageText: getLink(content)
                })
                if (no_reply_autoreply_data.length === 0) {
                    getEditorMessageData()
                    // replyMessage = `很抱歉機器人小編無法理解您的問題，真人小編稍後上線為您服務。<br/>(暑假期間，圖書館禮拜五及7/4~7/11休館，真人小編暫停服務)<br/>暑假開館詳細開放時間:<a href="https://lib.pccu.edu.tw/p/404-1012-127984.php?Lang=zh-tw">https://lib.pccu.edu.tw/p/404-1012-127984.php?Lang=zh-tw</a> <br/><br/>※真人小編平日上線服務時間為9:00~16:00<br/>例假日、國定假日真人小編暫停服務，請您耐心等候回覆，不便之處敬請見諒`
                    replyMessage = message_new
                    alltemp.push({
                        owner: false,
                        messageText: getLink(replyMessage)
                    })
                }
                else {
                    no_reply_autoreply_data.forEach(no_reply_autoreply_data_first => {
                        if (no_reply_autoreply_data_first?.name === "手動回覆") {

                            replyMessage = no_reply_autoreply_data_first.context
                        } else if (no_reply_autoreply_data_first?.name === null && no_reply_autoreply_data_first?.context === null) {

                            getEditorMessageData()
                            // replyMessage = `很抱歉機器人小編無法理解您的問題，真人小編稍後上線為您服務。<br/>(暑假期間，圖書館禮拜五及7/4~7/11休館，真人小編暫停服務)<br/>暑假開館詳細開放時間:<a href="https://lib.pccu.edu.tw/p/404-1012-127984.php?Lang=zh-tw">https://lib.pccu.edu.tw/p/404-1012-127984.php?Lang=zh-tw</a> <br/><br/>※真人小編平日上線服務時間為9:00~16:00<br/>例假日、國定假日真人小編暫停服務，請您耐心等候回覆，不便之處敬請見諒`
                            replyMessage = message_new
                        } else if (no_reply_autoreply_data_first?.name === null && no_reply_autoreply_data_first?.context !== null) {

                            // let no_reply_autoreply_data_first = no_reply_autoreply_data.find((ele) => true)
                            let message = no_reply_autoreply_data_first?.context
                            // let ownerContent = '';
                            // for (let i = 0; i < Object.keys(message).length; i++) {
                            //     ownerContent = ownerContent + (message[i] ?? { content: '' }).content;
                            // }
                            replyMessage = message
                        }else {

                            // let no_reply_autoreply_data_first = no_reply_autoreply_data.find((ele) => true)
                            let message = no_reply_autoreply_data_first?.message ?? {}
                            let ownerContent = '';
                            for (let i = 0; i < Object.keys(message).length; i++) {
                                ownerContent = ownerContent + (message[i] ?? { content: '' }).content;
                            }
                            replyMessage = ownerContent
                        }
                        alltemp.push({
                            owner: false,
                            messageText: getLink(replyMessage)
                        })
                    })
                }
                // alltemp.push({
                //     owner: true,
                //     messageText: getLink(content)
                // })
            })
            return [
                ...alltemp
            ]
        }))
    }, [noReplySelfData])

    useEffect(() => {
        endRef.current?.scrollIntoView(true)
    }, [chatLineData])
    useEffect(() => {
        getAutoReplyOption()
        getNoReplySelfData()
    }, [])
    return (
        <div style={{ height: '100vh', width: '100vw' }} >
            <div style={{ height: '100%', width: '100%', overflow: 'scroll' }} >
                <div
                    style={{
                        minHeight: '100%',
                        width: '100%',
                        padding: '1em 1em 8em 1em',
                        gap: '0.5em'
                    }} >
                    {
                        chatLineData.map((value, index) => {
                            return (<>
                                <ChatLine
                                    owner={value?.owner}
                                    messageText={value?.messageText}

                                />
                                <div
                                    {...(index === chatLineData.length - 1 && {
                                        ref: endRef
                                    })}
                                />
                            </>)
                        })
                    }
                </div>
                <div style={{ position: 'absolute', bottom: 0, width: '100%', overflowX: 'scroll' }} >
                    {/* <div
                        style={{
                            padding: '1em',
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '1em',
                            maxWidth: '100%',
                            overflow: 'scroll',
                        }}
                    >{
                            autoReplyOption
                                .filter((ele) => {
                                    return ele?.activation === 1
                                })
                                .map((value) => {
                                    return (value?.keyword_data || []).map((keyword_data) => {
                                        return <Button
                                            onClick={() => {
                                                sendKeyWord(keyword_data?.keyword_name)
                                            }}
                                            type='ghost'
                                            size='large'
                                            style={{
                                                backgroundColor: 'rgba(237, 255, 237, 1)',
                                                border: '1px solid rgba(181, 212, 148, 1)'
                                            }}
                                            shape='round'
                                        >
                                            {keyword_data?.keyword_name}
                                        </Button>
                                    })


                                })
                        }

                        <div
                            style={{
                                backgroundColor: 'rgba(237, 255, 237, 1)',
                                padding: '0.4em 1em',
                                borderRadius: '1.8em',
                                width: 'fit-content',
                                border: '1px solid rgba(181, 212, 148, 1)'
                            }} >
                            借閱紀錄
                        </div> 
                </div> */}
                    <div
                        style={{
                            height: '4em',
                            backgroundColor: 'rgba(255, 253, 247, 1)',
                            display: 'flex', justifyContent: 'center',
                            alignItems: 'center',
                            gap: '1em',
                            border: '1px solid rgba(196, 178, 135, 0.43)'
                        }} >
                        <Input
                            allowClear={true}
                            value={inputValue}
                            onChange={(e) => {
                                setInputValue((pre) => {
                                    return e.target.value
                                })
                            }}
                            placeholder="告訴我,你想知道什麼？"
                            style={{
                                borderRadius: '1.8em',
                                width: '80%',
                                padding: '0.4em 1em',
                            }}
                        />
                        <Button
                            loading={loading}
                            onClick={Send}
                            style={{
                                padding: 0,
                                height: '2.6em',
                                width: '2.6em',
                                borderRadius: '50%',
                            }} >
                            <ArrowRightOutlined />
                        </Button>
                    </div>
                </div>
            </div>
        </div >

    )
}

const ChatLine = ({
    owner = false,
    messageText = ""
}) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                justifyContent: owner ? 'flex-end' : 'flex-start',
                gap: '0.5em'
            }} >
            <div
                style={{
                    width: '3em',
                    height: '3em',
                    minHeight: '3em',
                    minWidth: '3em',
                    borderRadius: '50%',
                    backgroundColor: '#ff6666',
                    backgroundImage: owner ? ChatBotPictureOwer : ChatBotPicture,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    order: owner ? 3 : 1
                }}>
            </div>
            <div
                style={{
                    order: 2,
                }}
            >
                {owner && <div
                    style={{
                        backgroundColor: owner ? 'rgba(255, 230, 230, 1)' : '#FFFFE6',
                        padding: '0.4em 1em',
                        borderRadius: '1.8em',
                        width: 'fit-content',
                        border: owner ? '1px solid rgba(212, 148, 148, 1)' : '1px solid #D4BD94',
                        marginTop: '0.8em',
                        overflowWrap: 'anywhere',
                    }}
                    dangerouslySetInnerHTML={{ __html: messageText }}>
                </div>}
                {!owner && <div
                    style={{
                        backgroundColor: owner ? 'rgba(255, 230, 230, 1)' : '#FFFFE6',
                        padding: '0.4em 1em',
                        borderRadius: '1.8em',
                        width: 'fit-content',
                        border: owner ? '1px solid rgba(212, 148, 148, 1)' : '1px solid #D4BD94',
                        marginTop: '0.8em',
                        overflowWrap: 'anywhere',
                    }}
                    dangerouslySetInnerHTML={{ __html: messageText }}
                >
                </div>}
            </div>

            <div
                style={{
                    width: '3em',
                    minWidth: '3em',
                    order: owner ? 1 : 3
                }}>
            </div>
        </div>
    )
}

export default ChatRoom